import React, { Component, useEffect, useState } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,removeHtmlTags,getStatusSpan,
    isEmptyVariable, isEmptyArray,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
    import {  DialogSaveButton } from "../../../common/Global/globalStyles.style";
import {Modal} from 'react-bootstrap';

let userDetails = getLocalStorageVariables();

const GuidanceDialog = (props) => {
    const [rankingGuidance,setRankingGuidance] = useState("");
    const [showLoader,setShowLoader] = useState(false);
    const [formErrors,setFormErrors] = useState({});

    useEffect(()=>{
        if(props.guidanceDialogFlag){
            setShowLoader(false);
            if(!isEmptyVariable(props.selectedChecklistTaskObj?.rankingGuidance)){
                setRankingGuidance(props.selectedChecklistTaskObj.rankingGuidance)
            }else{
                setRankingGuidance("");
            }
        }
    },[props.guidanceDialogFlag])

    const handleChange = (e) => {
        const { value } = e.target;
        setRankingGuidance(value);
    }

    const handleAddRankingGuidance = () => {
        setShowLoader(true);
        userDetails = getLocalStorageVariables();
        fetch(Constants.UpdateChecklistTaskProperties,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                checkListTaskId:props.selectedChecklistTaskObj.checkListTaskId,
                weight:isEmptyVariable(props.selectedChecklistTaskObj.weight)?"":props.selectedChecklistTaskObj.weight,
                rankingGuidance:isEmptyVariable(rankingGuidance)?"":rankingGuidance,
            })
        })
        .then(response => { return response.json(); } )
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                props.handleGuidanceDialogClose(true);
            }else{
                setFormErrors({
                    ...formErrors,
                    rankingGuidance:data.responseMessage
                })
            }
        });
    }


    return (
        <Modal className="custom-dialog" show={props.guidanceDialogFlag} 
        backdrop="static">
            <Modal.Header>
                <h5>Ranking Guidance</h5>
                <button 
                    onClick={props.handleGuidanceDialogClose}
                    type="button" data-dismiss="modal">
                    <span class="material-icons">close</span>
                </button>
            </Modal.Header>
            <hr />
            <div class="modal-body">
                {
                    showLoader &&
                    <div class="loader"></div>
                }
                <div class="addnew-modal-form">
                    <div class="addnew-modal-form-group">
                        <p>Ranking Guidance</p>
                        <textarea type="text" placeholder="Enter Ranking Guidance"
                        name="rankingGuidance" value={rankingGuidance} 
                        onChange={handleChange}/>
                        {
                            !isEmptyVariable(formErrors['rankingGuidance']) &&
                            <span class="cm-error">{formErrors['rankingGuidance']}</span>
                        }
                    </div>
                </div>
                <div class="modal-close-save">
                    <div class="close-save-col">
                        <button onClick={props.handleGuidanceDialogClose} 
                            type="button" class="modal-close">Cancel</button>
                        <DialogSaveButton 
                            themeSettings={props.themeSettings}
                            onClick={handleAddRankingGuidance} type="button">Save</DialogSaveButton>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default GuidanceDialog;